import * as React from 'react';
import { Button, EButtonIntent } from '../Button';
import * as styles from './PhoneCallOnboarding.css';
export var PhoneCallOnboarding = function PhoneCallOnboarding(_ref) {
  var title = _ref.title,
      onCall = _ref.onCall;
  return /*#__PURE__*/React.createElement("div", {
    className: styles['container']
  }, /*#__PURE__*/React.createElement("picture", {
    className: styles['picture']
  }, /*#__PURE__*/React.createElement("source", {
    srcSet: "https://cdn.cian.site/frontend/collections-assets/onboarding/onboarding@1x.webp,\n                 https://cdn.cian.site/frontend/collections-assets/onboarding/onboarding@1.5x.webp 1.5x,\n                 https://cdn.cian.site/frontend/collections-assets/onboarding/onboarding@2x.webp 2x,\n                 https://cdn.cian.site/frontend/collections-assets/onboarding/onboarding@3x.webp 3x",
    type: "image/webp"
  }), /*#__PURE__*/React.createElement("img", {
    src: "https://cdn.cian.site/frontend/collections-assets/onboarding/onboarding@1.5x.png",
    srcSet: "https://cdn.cian.site/frontend/collections-assets/onboarding/onboarding@1x.png,\n                 https://cdn.cian.site/frontend/collections-assets/onboarding/onboarding@1.5x.png 1.5x,\n                 https://cdn.cian.site/frontend/collections-assets/onboarding/onboarding@2x.png 2x,\n                 https://cdn.cian.site/frontend/collections-assets/onboarding/onboarding@3x.png 3x",
    className: styles['image']
  })), /*#__PURE__*/React.createElement("div", {
    className: styles['content']
  }, title, /*#__PURE__*/React.createElement("p", {
    className: styles['description']
  }, "\u0417\u0430\u043F\u043E\u043C\u043D\u0438\u0442\u0435 ", /*#__PURE__*/React.createElement("strong", null, "\u043F\u043E\u0441\u043B\u0435\u0434\u043D\u0438\u0435 4 \u0446\u0438\u0444\u0440\u044B"), /*#__PURE__*/React.createElement("br", null), "\u0438 \u0432\u0432\u0435\u0434\u0438\u0442\u0435 \u043D\u0430 \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0435\u043C \u044D\u043A\u0440\u0430\u043D\u0435"), /*#__PURE__*/React.createElement("div", {
    className: styles['button-wrapper']
  }, /*#__PURE__*/React.createElement(Button, {
    intent: EButtonIntent.Primary,
    fill: true,
    onClick: onCall
  }, "\u0425\u043E\u0440\u043E\u0448\u043E, \u0436\u0434\u0443 \u0437\u0432\u043E\u043D\u043A\u0430!"))));
};
PhoneCallOnboarding.displayName = 'PhoneCallOnboarding';